import {APP_PREFIX_PATH} from '@/constants/route.constant'
import {NAV_ITEM_TYPE_ITEM, NAV_ITEM_TYPE_TITLE,} from '@/constants/navigation.constant'
import {Permissions} from "@/constants/app.constant";

const administrativeNavigationConfig = [
    {
        key: 'administrative',
        path: '',
        title: 'اداری',
        translateKey: '',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        permissions: [Permissions.administrative.value],
        subMenu: [
            {
                key: 'companies',
                path: `${APP_PREFIX_PATH}/companies`,
                title: 'شرکت‌ها',
                translateKey: 'شرکت‌ها',
                icon: 'IoBusiness',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.administrative.companies.value],
                subMenu: [],
            },
            {
                key: 'employees/menu',
                path: `${APP_PREFIX_PATH}/employees`,
                title: 'پرسنل',
                translateKey: 'پرسنل',
                icon: 'LuUsers',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.administrative.employees.value],
                subMenu: [
                    {
                        key: 'employees',
                        path: `${APP_PREFIX_PATH}/employees`,
                        title: 'پرسنل',
                        translateKey: 'پرسنل',
                        icon: 'LuUsers',
                        type: NAV_ITEM_TYPE_ITEM,
                        permissions: [Permissions.administrative.employees.value],
                        subMenu: [],
                    },
                    {
                        key: 'employees/relatives',
                        path: `${APP_PREFIX_PATH}/employees/relatives`,
                        title: 'همراهان پرسنل',
                        translateKey: 'همراهان پرسنل',
                        icon: 'FaPeopleRoof',
                        type: NAV_ITEM_TYPE_ITEM,
                        permissions: [Permissions.administrative.employeesRelatives.value],
                        subMenu: [],
                    },
                ],
            },
            {
                key: 'units',
                path: `${APP_PREFIX_PATH}/units`,
                title: 'واحدها',
                translateKey: 'واحدها',
                icon: 'PiBuilding',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.administrative.units.value],
                subMenu: [],
            },
            {
                key: 'positions',
                path: `${APP_PREFIX_PATH}/positions`,
                title: 'سمت‌ها',
                translateKey: 'سمت‌ها',
                icon: 'FaUserTag',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.administrative.positions.value],
                subMenu: [],
            },
        ]
    }
]

export default administrativeNavigationConfig
